import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-terms-information-sign',
  templateUrl: './registration-terms-information-sign.component.html',
  styleUrls: ['./registration-terms-information-sign.component.scss']
})
export class RegistrationTermsInformationSignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
